var cookieConsentButton = document.querySelector('.cookie-consent-button');

if(cookieConsentButton) {
	cookieConsentButton.addEventListener('click', function() {
		Cookie.set('cookie-consent', 'true', { expires: 360 });

		var splitDomain = location.host.split('.');

		if(splitDomain.length >= 2) {
			var domain = location.host.replace(splitDomain[0]+(splitDomain.length == 2 ? splitDomain[1] : ''), '');

			Cookie.set('cookie-consent', 'true', { domain: domain, expires: 360 });
		}
		Velocity(document.getElementById('cookie-consent'), {opacity: [0,1]}, {duration: 300, display: 'none'});
	});
}